import React, { ReactNode } from 'react';
import { getClassNameFactory, Button } from '@dcl/ui';
import './VideoTabList.css';
import { IVideoTabList } from '../../types';
import {
  ButtonColor,
  ButtonKind,
  IconPosition,
} from '@dcl/ui/dist/elements/Button';
import { CarrotIconUp } from './icons/CarrotIconUp';
import { CarrotIconDown } from './icons/CarrotIconDown';

export const VideoTabListMobile: React.FC<IVideoTabList> = (props) => {
  const getClassName = getClassNameFactory(VideoTabListMobile.displayName);
  const { playListUserData, currentVideoHandler } = props;

  const [showMenu, setShowMenu] = React.useState(false);

  const convertedVideoData = (dataArray) => {
    return dataArray.map((item) => {
      const entry_id = item.entry_id;
      const videoTitle = item.videoData?.videoTitle;
      return { label: videoTitle, value: entry_id };
    });
  };

  function getObjectByVideoEntryId(entryId) {
    return playListUserData.find((item) => item.entry_id === entryId);
  }

  const handleMenuClick = (value: ReactNode) => {
    const currentVideo = getObjectByVideoEntryId(value);
    currentVideo && currentVideoHandler(currentVideo);
    setShowMenu(false);
  };

  const toggleMore = () => {
    setShowMenu(!showMenu);
  };

  return (
    <div className={getClassName()}>
      <Button
        kind={ButtonKind.BUTTON}
        color={ButtonColor.SECONDARY}
        onClick={toggleMore}
        icon={showMenu ? <CarrotIconUp /> : <CarrotIconDown />}
        iconPosition={IconPosition.RIGHT}
        block={true}
      >
        Show menu
      </Button>
      {showMenu && (
        <div className={getClassName({ descendantName: 'tab-block' })}>
          <div className={getClassName({ descendantName: 'tab-modal' })}>
            <ul className={getClassName({ descendantName: 'tab-head' })}>
              {convertedVideoData(playListUserData).map((item) => (
                <li key={item.entryId}>
                  <a
                    href="javscript:void(0)"
                    onClick={() => handleMenuClick(item.value)}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

VideoTabListMobile.displayName = 'VideoTabListMobile';
